// The tab's empty state, on the same card chrome as the rest of the screen
// and as the home page's zero-fund card.
//
// Behaviour is unchanged, including the «انتقال صندوق به همیان» button, which
// has never had a handler. It is left alone rather than pointed at a plausible
// route — that is a product decision, not a styling one.
export default function NoFunds() {
    return (
        <div className="px-3 pt-4 pb-6 flex flex-col gap-3">
            <div className="bg-white border border-divider rounded-card p-5 text-center">
                <div className="w-10 h-10 mx-auto rounded-full bg-brand-soft flex items-center justify-center">
                    <svg
                        className="w-5 h-5 text-green-1"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 4v16m8-8H4"
                        />
                    </svg>
                </div>
                <p className="mt-3 text-base font-bold text-heading">
                    شما عضو صندوقی نیستید
                </p>
                <p className="mt-2 text-sm text-text-secondary leading-relaxed">
                    با دکمه‌ی + صندوق خودتان را بسازید، یا از مدیر صندوق بخواهید
                    لینک دعوت را برایتان بفرستد.
                </p>
            </div>

            <div className="bg-brand-soft rounded-card p-4 text-right">
                <p className="text-sm font-bold text-brand-deep">
                    انتقال صندوق به همیان
                </p>
                <p className="mt-2 text-sm text-text-body leading-relaxed">
                    اگر خارج از همیان مدیر صندوق قرض‌الحسنه‌ای دارای فعالیت و
                    سابقه هستید، با انتقال اطلاعات صندوقتان، در همیان به فعالیت
                    ادامه دهید.
                </p>
                <button className="w-full mt-4 bg-green-1 text-white rounded-full py-2 text-sm font-bold">
                    انتقال صندوق به همیان
                </button>
            </div>
        </div>
    )
}
